import { Component, OnInit } from '@angular/core';
import { AnnouncementOverlayService } from 'src/app/shared/services/announcement-overlay.service';
import {
  SafeHtml,
  SafeResourceUrl,
} from '@angular/platform-browser';
import {
  trigger,
  transition,
  style,
  animate
} from '@angular/animations';

export interface AnnouncementItem {
  title: string;
  content: SafeHtml | string;
  youtubeUrl?: SafeResourceUrl;
  driveUrl?: SafeResourceUrl;
}

@Component({
  selector: 'app-announcement-overlay',
  templateUrl: './announcement-overlay.component.html',
  styleUrls: ['./announcement-overlay.component.scss'],
  animations: [
    trigger('overlayAnim', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('200ms ease-out',
          style({ opacity: 1, transform: 'scale(1)' })
        )
      ]),
      transition(':leave', [
        animate('150ms ease-in',
          style({ opacity: 0, transform: 'scale(0.95)' })
        )
      ])
    ])
  ]
})

export class AnnouncementOverlayComponent implements OnInit {

  announcements: AnnouncementItem[] = [];

  constructor(
    private overlayService: AnnouncementOverlayService,
  ) {}

  ngOnInit(): void {
    this.overlayService.announcements$
      .subscribe(list => {
        this.announcements = list;
      });
  }

  close(): void {
    this.overlayService.hide();
  }

  isVideoAnnouncement(item: any): boolean {
    return !!item?.title?.startsWith('VIDEO_');
  }
  isMp4Video(item: AnnouncementItem): boolean {
    return item?.title?.startsWith('VIDEO_MP4');
  }

  isYoutubeVideo(item: AnnouncementItem): boolean {
    return item?.title?.startsWith('VIDEO_YOUTUBE');
  }

  isDriveVideo(item: AnnouncementItem): boolean {
    return item?.title?.startsWith('VIDEO_DRIVE');
  }


}
